"use client";

import React from "react";

const SinOddsCell = ({
  left,
  mid,
  right,
  leftTrend,
  midTrend,
  rightTrend,
  isEurope = false,
  isHandicap = false,
  tier = "",
  className = "",
}) => {
  const tierClass =
    tier === "ft"
      ? "kbv-sin-odds-ft"
      : tier === "ht"
        ? "kbv-sin-odds-ht"
        : "";
  const getTrendColor = (trend, defaultColor = "") => {
    const isUp =
      trend === "up" || trend === "increased" || trend === 1 || trend === "1";
    const isDown =
      trend === "down" || trend === "decreased" || trend === 2 || trend === "2";
    if (isUp) return "kbv-sin-up";
    if (isDown) return "kbv-sin-down";
    return defaultColor;
  };

  const renderTrendArrow = (trend) => {
    const isUp =
      trend === "up" || trend === "increased" || trend === 1 || trend === "1";
    const isDown =
      trend === "down" || trend === "decreased" || trend === 2 || trend === "2";
    if (isUp)
      return (
        <span
          className="shrink-0 inline-block w-[10px] h-[10px] lu-odds-status--up ml-0.5"
          aria-hidden="true"
        />
      );
    if (isDown)
      return (
        <span
          className="shrink-0 inline-block w-[10px] h-[10px] lu-odds-status--down ml-0.5"
          aria-hidden="true"
        />
      );
    return null;
  };

  return (
    <span
      className={`${isEurope ? "md:text-[14px] " : ""}${tierClass ? ` ${tierClass}` : " box-border kbv-sin-odds-bg"} text-[12px] md:text-[14px] flex h-[34px] w-full min-w-0 items-center justify-between rounded p-0 font-normal md:h-8 md:px-1 ${tier ? "!bg-transparent !p-0 !h-7 md:!h-7" : "md:p-1.5"} ${className}`}
    >
      {/* Left Value */}
      <span
        className={`text-[12px] md:text-[16px] flex-1 text-center font-semibold flex items-center justify-center ${getTrendColor(leftTrend, isHandicap ? "kbv-sin-up" : "kbv-sin-txt-muted")}`}
      >
        {left ?? "-"}
        {renderTrendArrow(leftTrend)}
      </span>

      {/* Middle Value */}
      {isHandicap ? (
        <span className="kbv-sin-txt-muted text-[12px] md:text-[16px] flex-1 text-center font-medium leading-tight">
          {mid ?? "-"}
        </span>
      ) : (
        <span
          className={`text-[12px] md:text-[16px] flex-1 text-center font-medium flex items-center justify-center ${getTrendColor(midTrend, "kbv-sin-up")}`}
        >
          {mid ?? "-"}
          {renderTrendArrow(midTrend)}
        </span>
      )}

      {/* Right Value */}
      <span
        className={`text-[12px] md:text-[16px] flex-1 text-center font-semibold flex items-center justify-center ${getTrendColor(rightTrend, isHandicap ? "kbv-sin-up" : "kbv-sin-txt-muted")}`}
      >
        {right ?? "-"}
        {renderTrendArrow(rightTrend)}
      </span>
    </span>
  );
};

export default SinOddsCell;
